import * as Common from "../../commons/common"

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number
  subject_code: number
  subject_name: string
  report_no: number
  name: string
  page_count: number
  answer_image_completed: boolean
  isSelected: boolean = false

  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.subject_code = base_sheet.subject_code;
    this.subject_name = base_sheet.subject_name;
    this.report_no = base_sheet.report_no;
    this.name = base_sheet.name;
    this.page_count = base_sheet.page_count;
    this.answer_image_completed = base_sheet.answer_image_completed;
  }
}

export class Part1Option {
  value: string
  text: string

  constructor(part1: string){
    // プルダウン表示文言は画面仕様に合わせて「大問N」で固定
    this.value = part1;
    this.text = `大問${part1}`;
  }
}

export class PageItem {
  page: number
  base64Image: string
  baseWidth: number
  baseHeight: number
  autoReviewTextTemplates: AutoReviewTextTemplate[] = []
  autoReviewImageTemplates: AutoReviewImageTemplate[] = []
  templateIdx: number = 0

  constructor(page: number, base64Image: any, size: any, textTemplates: any[], imageTemplates: any[]){
    this.page = page;
    this.base64Image = base64Image;
    this.baseWidth = size.width;
    this.baseHeight = size.height;
    this.setAutoReviewTextTemplates = textTemplates;
    this.setAutoReviewImageTemplates = imageTemplates;
  }

  set setAutoReviewTextTemplates(templates: any[]) {

    this.autoReviewTextTemplates = [];

    templates.filter((x: any) => x.page == this.page).forEach((x: any) => {

      // 未入力のテキストは削除
      if(x.text == null || x.text.replace(/\r?\n/g, '').trim() == "" || x.width == 0 || x.height == 0){
        return;
      }

      const autoReviewTextTemplate = new AutoReviewTextTemplate();
      autoReviewTextTemplate.id = x.id;
      // target_type追加前の旧データを考慮し、未設定時は合計点講評として扱う
      autoReviewTextTemplate.target_type = x.target_type ?? AutoReviewTargetTypeEnum.TotalScore;
      autoReviewTextTemplate.part1 = x.part1;
      autoReviewTextTemplate.score_from = x.score_from;
      autoReviewTextTemplate.score_to = x.score_to;
      autoReviewTextTemplate.page = x.page;
      autoReviewTextTemplate.text = x.text;
      autoReviewTextTemplate.idx = this.templateIdx++;
      autoReviewTextTemplate.font_size = x.font_size;
      autoReviewTextTemplate.line_height = x.line_height;
      autoReviewTextTemplate.color = x.color;
      autoReviewTextTemplate.x = x.x;
      autoReviewTextTemplate.y = x.y;
      autoReviewTextTemplate.width = x.width;
      autoReviewTextTemplate.height = x.height;
      autoReviewTextTemplate.direction = x.direction;
      autoReviewTextTemplate.template_type = TemplateTypeEnum.Text;
      autoReviewTextTemplate.base64_text = Common.createBase64Text(autoReviewTextTemplate);


      this.autoReviewTextTemplates.push(autoReviewTextTemplate);
    });
  }

  set setAutoReviewImageTemplates(templates: any[]) {

    this.autoReviewImageTemplates = [];

    templates.filter((x: any) => x.page == this.page).forEach((x: any) => {

      const autoReviewImageTemplate = new AutoReviewImageTemplate();
      autoReviewImageTemplate.id = x.id;
      // target_type追加前の旧データを考慮し、未設定時は合計点講評として扱う
      autoReviewImageTemplate.target_type = x.target_type ?? AutoReviewTargetTypeEnum.TotalScore;
      autoReviewImageTemplate.part1 = x.part1;
      autoReviewImageTemplate.score_from = x.score_from;
      autoReviewImageTemplate.score_to = x.score_to;
      autoReviewImageTemplate.page = x.page;
      autoReviewImageTemplate.idx = this.templateIdx++;
      autoReviewImageTemplate.x = x.x;
      autoReviewImageTemplate.y = x.y;
      autoReviewImageTemplate.width = x.width;
      autoReviewImageTemplate.height = x.height;
      autoReviewImageTemplate.template_type = TemplateTypeEnum.Image;
      autoReviewImageTemplate.base64_image = x.base64_image;

      this.autoReviewImageTemplates.push(autoReviewImageTemplate);
    });
  }
}


export class AutoReviewTextTemplate {
  id: number
  idx: number
  target_type: number = AutoReviewTargetTypeEnum.TotalScore
  part1: string | null = null
  score_from: number | null = null
  score_to: number | null = null
  page: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number
  base64_text: string = null
  is_active: boolean = false
  is_edited: boolean = false
  is_disp: boolean = true
  template_type: number = null
}

export class AutoReviewImageTemplate {
  id: number
  idx: number
  target_type: number = AutoReviewTargetTypeEnum.TotalScore
  part1: string | null = null
  score_from: number | null = null
  score_to: number | null = null
  page: number
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string = null
  is_active: boolean = false
  is_edited: boolean = false
  is_disp: boolean = true
  template_type: number = null
}

export class AutoReviewImageBookmark {
  id: number
  width: number = null
  height: number = null
  base64_image: string = null

  constructor(x: any){
    this.id = x.id;
    this.width = x.width;
    this.height = x.height;
    this.base64_image = x.base64_image;
  }
}

export class ParamAutoReviewTextTemplate {
  id: number
  idx: number
  target_type: number
  part1: string | null = null
  score_from: number | string | null = null
  score_to: number | string | null = null
  page: number
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number
  base64_text: string
  is_edited: boolean = false

  constructor(x: AutoReviewTextTemplate){
    this.id = x.id;
    this.target_type = x.target_type;
    this.part1 = x.part1;
    this.score_from = x.score_from;
    this.score_to = x.score_to;
    this.page = x.page;
    this.text = x.text;
    this.color = x.color;
    this.font_size = x.font_size;
    this.line_height = x.line_height;
    this.x = x.x;
    this.y = x.y;
    this.width = x.width;
    this.height = x.height;
    this.direction = x.direction;
    this.base64_text = x.base64_text;
    this.is_edited = x.is_edited;
  }
}

export class ParamAutoReviewImageTemplate {
  id: number
  idx: number
  target_type: number
  part1: string | null = null
  score_from: number | string | null = null
  score_to: number | string | null = null
  page: number
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_image: string
  is_edited: boolean = false

  constructor(x: AutoReviewImageTemplate){
    this.id = x.id;
    this.target_type = x.target_type;
    this.part1 = x.part1;
    this.score_from = x.score_from;
    this.score_to = x.score_to;
    this.page = x.page;
    this.x = x.x;
    this.y = x.y;
    this.width = x.width;
    this.height = x.height;
    this.base64_image = x.base64_image;
    this.is_edited = x.is_edited;
  }
}

export class SearchCondition {
  sheet_code: string = ""
  nendo: string = ""
  report_no: string = ""
  subject_code: string = ""
  page: number = 1
  row_count: number =  20
  currentPage: number = 1
}

export enum TemplateTypeEnum {
  Text = 1,
  Image = 2,
}

export enum AutoReviewTargetTypeEnum {
  TotalScore = 1,
  Part1 = 2,
}
